/* eslint-disable prettier/prettier */
//import { handleTabs } from '@/utils/routes'
//let numeral = require('numeral')
import { mapActions } from 'vuex'
export default {
  data() {
    return {}
  },

  computed: {
    refreshPageList() {
      return this.$store.getters['notify/refreshPageList']
    },
    reloadPage() {
      return this.$store.getters['notify/reloadPage'][this.$route.name] ?? false
    },
    autoReload() {
      return this.$store.getters['notify/autoReload'][this.$route.name] ?? true
    },
  },
  watch: {
    $route: {
      handler(router) {
        if (
          this.$baseLodash.keys(router.query).length > 0 &&
          router.name == this.$options.name
        ) {
          this.$nextTick(() => {
            if (this.autoReload) {
              this.$store.dispatch('notify/setAutoReload', {
                name: this.$options.name,
                value: false,
              })
              this.fetchData && this.fetchData()
            }
          })
          return
        }
      },
      immediate: true,
    },
  },

  beforeDestroy() {
    this.$store.dispatch('notify/setReloadPage', {
      name: this.$options.name,
      value: false,
    })
    this.$store.dispatch('notify/setAutoReload', {
      name: this.$options.name,
      value: true,
    })
  },
  mounted() {
    this.getVabTable()
  },
  activated() {
    if (
      this.$baseLodash.includes(
        this.refreshPageList,
        this.$baseLodash.toUpper(this.$route.name)
      )
    ) {
      this.$nextTick(() => {
        this.fetchData()
      })
      this.delRefresh(this.$route.name)
    }
    this.closeTooltip()
  },
  methods: {
    ...mapActions({
      delRefresh: 'notify/delRefresh',
    }),
    closeTooltip() {
      this.$nextTick(() => {
        let list = document.getElementsByClassName('el-tooltip__popper')
        if (list.length > 0) {
          list[list.length - 1].style.display = 'none'
        }
      })
    },
    getComponentList(vm, componentName, result = []) {
      vm.$children.forEach((child) => {
        var name = child.$options.componentName
        if (name == componentName) {
          result.push(child)
        } else {
          this.getComponentList(child, componentName, result)
        }
      })
      return result
    },
    getVabTable() {
      let vabTableList = this.getComponentList(this, 'VabTable') ?? []
      let vabQueryFormList = this.getComponentList(this, 'VabQueryForm') ?? []
      if (vabTableList.length == 0 || vabQueryFormList.length == 0) return
      vabTableList[0].vmQueyForm = vabQueryFormList[0]
    },
    setTimeNull(list) {
      if (this.$baseLodash.isArray(list) && list.length > 0) {
        list.filter((item) => {
          item.changeDate = null
          item.changeTime = null
        })
      }
    },
  },
}
